import { z } from "zod";
export const OutageFailSafeEvidenceV1Schema = z
    .object({
    schemaVersion: z.literal("outage-fail-safe-evidence.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalOutageFailSafeEvidence(recordedAt) {
    return OutageFailSafeEvidenceV1Schema.parse({
        schemaVersion: "outage-fail-safe-evidence.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=outage-fail-safe-evidence.js.map